import VueHotkey from 'v-hotkey';
import Vue from 'vue';

Vue.use(VueHotkey);
